import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { ScoutingFlowService } from '../services/scouting-flow.service';
import { ReportViewModel } from '../models/ReportModels';
import { ReportOverallGradesComponent } from '../components/report-overall-grades/report-overall-grades.component';
//import { SharedModuleModule } from 'src/app/shared-module/shared-module.module';
import { CommonModule } from '@angular/common';
import { ReportOverallGameComponent } from '../components/report-overall-game/report-overall-game.component';
import { ReportOverallSkillsgroupComponent } from '../components/report-overall-skillsgroup/report-overall-skillsgroup.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon, MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-report-view-dialog',
  imports: [ReportOverallGradesComponent, ReportOverallGameComponent, ReportOverallSkillsgroupComponent, CommonModule, MatDividerModule, MatDialogModule, MatButtonModule, MatIconModule, MatIcon
    //  , ReportViewSkillsComponent
  ],
  templateUrl: './report-view-dialog.component.html',
  styleUrls: ['./report-view-dialog.component.css']
})
export class ReportViewDialogComponent implements OnInit {

  Report: ReportViewModel;

  constructor(@Inject(MAT_DIALOG_DATA) public data2: any, public dialogRef: MatDialogRef<ReportViewDialogComponent>, private _reportService: ScoutingFlowService) { }

  ngOnInit() {
    this.getReport(this.data2.ReportId);
  }

  close() {
    this.dialogRef.close();
  }

  getReport(test: string) {

    this._reportService.getReport(test).subscribe(report => {
      this.Report = report;
      //console.log(this.Report);
      //console.log(this.Report.SCReport);
      //console.log(this.Report.SCReport.Player);
    });

  }

}
